module.exports = __webpack_public_path__ + "static/media/cardBg.68f30c6e.jpg";